<template>
    <div>
        <v-btn 
            @click.native="showDialog=true"
            class="select-service-button"
            style="margin-left:0"
            :style="{backgroundColor: selectedService?selectedService.color:'#e0e0e0' }"
        > 
            <span v-if="selectedService">
                <strong>{{selectedService.category}} &gt; {{selectedService.name}}</strong><br>
                Durata: {{selectedService.time}}<br>
            </span>
            <span v-else>
                Selezionare...
            </span>
        </v-btn>
        <v-dialog
                v-model="showDialog"
                width="500"
            >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Seleziona servizio
                </v-card-title>
                <v-card-text>
                    <v-card 
                        class="service-for-picker"
                        v-for="service in services" :key="service.id" 
                        @click="serviceClicked(service)"
                        :style="{backgroundColor: service.color }"
                    >
                        <v-card-text>
                            <div class="inline-block" style="max-width: calc(100% - 70px);">
                                <strong>{{service.category}} &gt; {{service.name}}</strong><br>
                                Durata: {{service.time}}<br>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showDialog = false"
                >
                    Annulla
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
const axios = require('axios').default;
export default {
  name: "SelectService",
  props: ["value"],
  data() {
    return {
        showDialog: false,
        selectedValue: null,
        services:[]
    };
  },
  methods: {
    async getServices(){
        let vm = this;
        try {
            const response = await axios({
                method: "GET",
                url: vm.$API_BASE_URL + "getServices.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            });
            if (response.status == 200) {
                vm.services = [];
                vm.services = response.data.resources;
            } 
            else{
                alert("Si è verificato un errore durante il caricamento");
            }
        } catch(error) {
            if(error.response && (error.response.status==403||error.response.status==401)){
                vm.$router.push({name: 'login'});
            }
            else{
                alert("Si è verificato un errore durante il caricamento");
                console.error(error)
            }
        }
    },
    serviceClicked(service){
        let vm = this;
        vm.selectedValue = service.id;
        vm.showDialog = false;
        vm.$emit("input", vm.selectedValue);
    }
  },
  mounted() {
    let vm = this;
    vm.getServices();
  },
  computed:{
    selectedService(){
        let vm = this;
        return vm.services.find(service=>service.id == vm.selectedValue);
    }
  },
  watch: {
    value: {
      handler: function (newValue) {
        let vm = this;
        vm.selectedValue=newValue;
      },
      immediate: true,
    }
  },
};
</script>

<style>
    .cardbutton .v-btn__content{
        display:block!important;
        text-align: left;
    }
    .cardbutton{
        padding: 30px 20px;
    }
    .v-card.service-for-picker{
        margin-bottom:5px;
    }
    .select-service-button.v-btn {
        text-align: left;
        padding: 25px 10px 25px 10px;
        text-transform: none;
    }
</style>
